<div class="container">
    <div class="row">
        <div class="col">
            <p class="logo header">PORTFOLIO - Connection Status</p>
        </div>
    </div>
</div>
<div>
    <div>
        <strong>Status</strong>
    </div>
    <p>{{AliveResponse}}</p>
</div>

